import { del, post, get, put, getBodyOnly } from "./api_helper";
import * as url from "./url_helper";
//Register trial user
// const putRegisterTrialUser = (data) => put(url.POST_NEW_TRIAL_USER, data);
const putRegisterTrialUser = (data) => post(url.POST_NEW_TRIAL_USER, data);

// Get trial user
const getRegisterTrialUser = () => getBodyOnly(url.GET_NEW_TRIAL_USER);

// Update trial user
const updateRegisterTrialUser = (data) => put(url.UPDATE_NEW_TRIAL_USER, data);

const deleteRegisterTrialUser = (data) => del(url.DELETE_NEW_TRIAL_USER, data);

// Send trial user email.
const sendRegisterTrialUserEmail = (data) =>
  put(url.SEND_NEW_TRIAL_USER_EMAIL, data);

// Login
const postLogin = (data) => post(url.POST_LOGIN, data);

const addUser = (data) => post(url.ADD_COGNITO_USER, data);

// Forget Password
const postForgetPwd = (data) => put(url.POST_FORGET_PASSWORD, data);

const resetPasswordFrgt = (data) => {
  return put(url.POST_RESET_FORGOT_PASSWORD, data);
};

const getCognitoUser = () => getBodyOnly(url.GET_NEW_COGNITO_USER);

//Added for update/delete cognito user
// Update cognito user
const updateUser = (user) => {
  console.log("in updateUser API user = ", user);
  put(url.COGNITO_USER, user);
};

// Delete cognito user
const deleteUser = (userObj) => {
  console.log("in deleteUser API user = ", userObj);
  del(url.COGNITO_USER, { params: { username: userObj.username } });
};

// Get all organizations
//TODO: Update as per parameter
const getOrganizations = () => get(url.ORGANIZATION);

// Get all pre onboarded organizations
const getPreOnBoardedOrganizations = () => get(url.ORGANIZATION_PRE_ON_BOARDED);

//Delete PreOnboardedOrganizations
const deletePreOnBoardedOrganizations = (token) => del(url.ORGANIZATION_PRE_ON_BOARDED, {params: {token: token}});

// Send activation link for pre onboarded organization
const resendOrgOnboardActivationLink = (token) => {
  return put(
    `${url.ORGANIZATION_PRE_ON_BOARDED_ACTIVATION_LINK}?token=${token}`
  );
};

// // HP API call simulation of above function
// const resendOrgOnboardActivationLink = (token) => {
//   console.log("----== addOrgUser ", url.ORGANIZATION_PRE_ON_BOARDED_ACTIVATION_LINK, " token = ", token );
//   return new Promise((resolve, reject) => {
//     // Simulate a delay of 3 seconds before resolving the Promise
//     setTimeout(() => {
//       console.log("~~~~~ resendOrgOnboardActivationLink: Returning success from API call");
//       resolve({ status: 200, data: "Activation link resent Successfully!" }); 
//       // console.log("~~~~~ addOrgUser: Returning error from API call");
//       // reject({ status: 504, data: "Profile Role info failed! " });
//     }, 3000); // 3000 milliseconds = 3 seconds
//   });
// };

// Add an organization
const addOrganization = (organization) => post(url.ORGANIZATION, organization);

// Create a trial account user
const registerTrialAccountUser = (trialAcctUser) =>
  post(url.ORGANIZATION_TRIAL_ACCOUNT_USER, trialAcctUser);

// Update an organization
const updateOrganization = (organization) =>
  put(url.ORGANIZATION, organization);

// delete an organization
const deleteOrganization = (orgCode) =>
  del(url.ORGANIZATION, {
    params: { orgcode: orgCode },
  });

// Get all organization accounts
const getOrgAccounts = (orgCode) =>
  get(url.ORGANIZATION_ACCOUNT, {
    params: { orgcode: orgCode },
  });

// Update an organization account
const updateOrgAccount = (data) => put(url.ORGANIZATION_ACCOUNT, data);

// Add an organization account
const addOrgAccount = (data) => post(url.ORGANIZATION_ACCOUNT, data);

// delete an organization account
const deleteOrgAccount = ({orgCode, orgAccountCode}) =>
  del(url.ORGANIZATION_ACCOUNT, {
    params: { acccode: orgAccountCode, orgCode: orgCode },
  });

// Get organization account workloads
const getOrgAccountWorkloads = (accountNumber) =>
  get(url.ORGANIZATION_ACCOUNT_WORKLOADS, {
    params: { accountNumber: accountNumber },
  });

// Update organization account workload
const updateOrgAccountWorkload = (data) =>
  put(url.ORGANIZATION_ACCOUNT_WORKLOADS, data);

// Get scan schedules
const getScanSchedules = (orgCode, accountCode) =>
  get(url.SCAN_SCHEDULES, {
    params: { orgCode, accountCode },
  });

// Update scan schedule frequency
const updateScanScheduleFrequency = (orgCode, accountCode, data) =>
  put(`${url.SCAN_SCHEDULES_FREQUENCY}?orgCode=${orgCode}&accountCode=${accountCode}`, data);

// Post feature configuration
const postFeatureConfiguration = (data) => post(url.FEATURE_CONFIGURATION, data);

// delete an organization user
const deleteOrgUser = (email, orgCode) => {
    console.log("🚀 ~ deleteOrgUser ~ orgCode:", orgCode)
    console.log("🚀 ~ deleteOrgUser ~ email:", email)
    return del(url.ORGANIZATION_USER, {
        params: { email: email, orgCode: orgCode },
    });
};

// Get all organization billing
const getOrgBilling = (orgCode) =>
  get(url.ORGANIZATION_BILLING, {
    params: { orgcode: orgCode },
  });

// Update organization billing
const updateOrgBilling = (data) => put(url.ORGANIZATION_BILLING, data);

// Create organization billing
const createOrgBilling = (data) => post(url.ORGANIZATION_BILLING, data);

// Create organization billing usage
const createOrgBillingUsage = (data) => post(url.ORGANIZATION_BILLING_USAGE, data);

// Get organization billing usage
const getOrgBillingUsage = (accnumber) => get(url.ORGANIZATION_BILLING_USAGE, {
  params: {accnumber: accnumber},
});

// Delete organization billing
const deleteOrgBilling = (deleteOrgBillingPayload) => 
  del(url.ORGANIZATION_BILLING, {
    params: {
      billingId: deleteOrgBillingPayload.billingId,
      orgcode: deleteOrgBillingPayload.orgcode,
      accountNumber: deleteOrgBillingPayload.accountNumber,
      customerIdentifier: deleteOrgBillingPayload.customerIdentifier,
    }
  });

// GLOBAL LICENSE MANAGEMENT
// const getGlobalLicense = () => getBodyOnly(url.GLOBAL_LICENSE);
const getGlobalLicense = (orgCode) => get(url.GLOBAL_LICENSE, {
    params: { orgCode: orgCode},
  });

//Added for update/delete cognito user
// Update cognito user
const updateGlobalLicense = (license) => {
  console.log("in updateLicense API License = ", license);
  return put(url.GLOBAL_LICENSE, license);
};

const addComplianceAddons = (complianceAddons) => {
  console.log("in addComplianceAddons complianceAddons = ", complianceAddons);
  return post(url.ADD_COMPLIANCE_ADDONS, complianceAddons);
}

// CUSTOM LICENSE MANAGEMENT
const getCustomLicenses = (orgCode) =>
  get(url.CUSTOM_LICENSE, {
    params: { orgcode: orgCode },
  });

const updateCustomLicense = (customLicense) => {
  console.log("in updateCustomLicense API customLicense = ", customLicense);
  return put(url.CUSTOM_LICENSE, customLicense);
};

const addCustomLicense = (customLicense) => {
  console.log("in addCustomLicense API customLicense = ", customLicense);
  return post(url.CUSTOM_LICENSE, customLicense);
};

//TODO: add required parameter
const deleteCustomLicense = (orgCode, licenseName) =>{
  console.log("in deleteCustomLicense API, orgCode = ", orgCode, "licenseName = ",licenseName);
  return del(url.CUSTOM_LICENSE, {
    params: { orgCode: orgCode, licenseName: licenseName},
  });
}

// // HP API call simulation of above function
// const deleteCustomLicense = (orgCode, licenseName) => {
//   console.log("----== deleteCustomLicense ", url.CUSTOM_LICENSE, " orgCode = ", orgCode, " licenseName = ", licenseName );
//   return new Promise((resolve, reject) => {
//     // Simulate a delay of 3 seconds before resolving the Promise
//     setTimeout(() => {
//       console.log("~~~~~ addOrgUser: Returning success from API call");
//       resolve({ status: 200, data: "Custom license deleted Successfully" }); 
//       // console.log("~~~~~ addOrgUser: Returning error from API call");
//       // reject({ status: 504, data: "Profile Role info failed! " });
//     }, 3000); // 3000 milliseconds = 3 seconds
//   });
// };


// Global IaaC API
const getGlobalIaac = (orgCode) => {
  console.log("In getGlobalIaac, orgCode: ", orgCode);
  if(orgCode===null || orgCode===undefined){
    return get(`${url.GLOBAL_IAAC}?orgCode=`);
  }
  return get(`${url.GLOBAL_IAAC}?orgCode=${orgCode}`);
};

const putGlobalIaac = (iaac) => {
  console.log("In putGlobalIaac, iaac = ", iaac);
  return put(url.GLOBAL_IAAC, iaac);
};

// Organization IaaC API
const getOrganizationIaac = (orgCode) => {
  console.log("In getOrganizationIaac ");
  return get(`${url.ORGANIZATION_IAAC}?orgCode=${orgCode}`);
};

const postOrganizationIaac = (orgCode, iaac) => {
  console.log("In postOrganizationIaac, iaac = ", iaac);
  return post(`${url.ORGANIZATION_IAAC}?orgCode=${orgCode}`, iaac);
};

const putOrganizationIaac = (orgCode, iaac, subscriptionChange) => {
  console.log("In putOrganizationIaac, orgCode= ",
    orgCode, "iaac = ", iaac, " subscriptionChange = ", subscriptionChange);
  const iaacRequest = {...iaac, orgCode: orgCode}
  // return put(`${url.ORGANIZATION_IAAC}?orgCode=${orgCode}`, iaac);
  return put(`${url.ORGANIZATION_IAAC}?subscriptionChange=${subscriptionChange}`, iaacRequest);
};

const deleteOrganizationIaac = (orgCode) => {
  console.log("In deleteOrganizationIaac, orgCode= ",orgCode);
  // return put(`${url.ORGANIZATION_IAAC}?orgCode=${orgCode}`, iaac);
  return del(`${url.ORGANIZATION_IAAC}?orgCode=${orgCode}`);
};

const addOrgUser = (orgUser) => {
  console.log("In addOrgUser, orgUser= ",orgUser);
  return post(`${url.ORGANIZATION_USER}`,orgUser)
}

// // HP API call simulation of above function
// const addOrgUser = (orgUser) => {
//   console.log("----== addOrgUser ", url.ORGANIZATION_USER, " user = ", orgUser );
//   return new Promise((resolve, reject) => {
//     // Simulate a delay of 3 seconds before resolving the Promise
//     setTimeout(() => {
//       console.log("~~~~~ addOrgUser: Returning success from API call");
//       resolve({ status: 200, data: "Account created Successfully" }); 
//       // console.log("~~~~~ addOrgUser: Returning error from API call");
//       // reject({ status: 504, data: "Profile Role info failed! " });
//     }, 3000); // 3000 milliseconds = 3 seconds
//   });
// };

const editOrgUser = (orgUser) => {
  console.log("In editOrgUser, orgUser= ",orgUser);
  return put(`${url.ORGANIZATION_USER}`,orgUser)
}

// // HP API call simulation of above function
// const editOrgUser = (orgUser) => {
//   console.log("----== editOrgUser ", url.ORGANIZATION_USER, " user = ", orgUser );
//   return new Promise((resolve, reject) => {
//     // Simulate a delay of 3 seconds before resolving the Promise
//     setTimeout(() => {
//       console.log("~~~~~ editOrgUser: Returning success from API call");
//       resolve({ status: 200, data: "Account updated Successfully" }); 
//       // console.log("~~~~~ addOrgUser: Returning error from API call");
//       // reject({ status: 504, data: "Profile Role info failed! " });
//     }, 3000); // 3000 milliseconds = 3 seconds
//   });
// };

// const deleteOrgUser = (orgUser) => {
//   console.log("In deleteOrgUser, orgUser= ",orgUser);
//   return put(`${url.ORGANIZATION_USER}`,orgUser)
// }

const malwarelogs = () => {
  console.log("In malwarelogs ");
  return get(`${url.MALWARE_SCAN_LOGS}`);
}

// Update an organization account
const extendFreeLicense = (data) => put(url.EXTEND_TRIAL, data);


export {
  putRegisterTrialUser,
  getRegisterTrialUser,
  sendRegisterTrialUserEmail,
  updateRegisterTrialUser,
  postLogin,
  deleteRegisterTrialUser,
  addUser,
  postForgetPwd,
  resetPasswordFrgt,
  getCognitoUser,
  updateUser,
  deleteUser,
  getOrganizations,
  getPreOnBoardedOrganizations,
  resendOrgOnboardActivationLink,
  addOrganization,
  updateOrganization,
  deleteOrganization,
  registerTrialAccountUser,
  getOrgAccounts,
  updateOrgAccount,
  addOrgAccount,
  deleteOrgAccount,
  getOrgAccountWorkloads,
  updateOrgAccountWorkload,
  getScanSchedules,
  updateScanScheduleFrequency,
  deleteOrgUser,
  getGlobalLicense,
  updateGlobalLicense,
  addCustomLicense,
  getCustomLicenses,
  updateCustomLicense,
  addComplianceAddons,
  deleteCustomLicense,
  getGlobalIaac,
  putGlobalIaac,
  getOrganizationIaac,
  postOrganizationIaac,
  putOrganizationIaac,
  deleteOrganizationIaac,
  addOrgUser,
  editOrgUser,
  malwarelogs,
  extendFreeLicense,
  deletePreOnBoardedOrganizations,
  getOrgBilling,
  updateOrgBilling,
  createOrgBilling,
  deleteOrgBilling,
  createOrgBillingUsage,
  getOrgBillingUsage,
  postFeatureConfiguration,
};